import { usePCScrollLock } from './usePCScrollLock';
import { useCustomScrollLock } from './useCustomScrollLock';

/**
 * 디바이스/뷰포트에 맞춰 자동 분기되는 통합 스크롤 잠금 composable.
 *
 * - PC(>768px): usePCScrollLock — `overflow: hidden` + 스크롤바 너비만큼
 *   `padding-right` 보정으로 레이아웃 jitter 방지 (watch immediate: true)
 * - 모바일(≤768px): useCustomScrollLock — `position: fixed; top: -scrollY`로
 *   iOS Safari 포함 모바일 브라우저에서 확실히 스크롤 잠금
 *   (내부 watch가 immediate 없으므로, v-if로 마운트되며 이미 isLocked=true인
 *    경우를 위해 setup 시점에 직접 disableScroll 호출하여 보정)
 *
 * 두 방식은 함께 적용하면 충돌(width 100% + padding-right로 가로 스크롤 등장 등)
 * 위험이 있어 setup 시점의 미디어쿼리로 한 가지만 채택.
 *
 * @param {Ref<boolean>|ComputedRef<boolean>} isLocked - 잠금 여부
 */
export const useScrollLock = (isLocked) => {
  const isMobileScreen =
    typeof window !== 'undefined' &&
    window.matchMedia('(max-width: 768px)').matches;

  if (isMobileScreen) {
    const { disableScroll } = useCustomScrollLock({ activeScrollLock: isLocked });
    // v-if로 컴포넌트가 lock 상태에서 마운트된 경우 watch가 발동하지 않으므로 직접 호출
    if (isLocked?.value) {
      disableScroll();
    }
  } else {
    usePCScrollLock(isLocked);
  }
};
